import React from 'react';
import Paper from '@mui/material/Paper';
import './MerchantAccountDetailsCard.scss';
import { Divider } from '@mui/material';
import { MERCHANT_ACCOUNT_DETAILS_CONTENT, MERCHANT_STREAM_DETAILS_CONTENT, MERCHANT_OTTER_DETAILS_CONTENT,MERCHANT_CHECKMATE_DETAILS_CONTENT, MERCHANT_OLO_DETAILS_CONTENT, MERCHANT_CREATEADMIN_DETAILS_CONTENT } from '../../../constants/Admin/MerchantAccountConstants';


const CONTENT_MAP = {
	'': MERCHANT_ACCOUNT_DETAILS_CONTENT,
	'checkmate': MERCHANT_CHECKMATE_DETAILS_CONTENT,
	'olo': MERCHANT_OLO_DETAILS_CONTENT,
	'otter': MERCHANT_OTTER_DETAILS_CONTENT,
	'stream': MERCHANT_STREAM_DETAILS_CONTENT,
	'createAdmin': MERCHANT_CREATEADMIN_DETAILS_CONTENT
  };

const  MerchantAccountDetailsCard = ({selectedAggregator}) => {

	const content = CONTENT_MAP[selectedAggregator] || [];

	return (
		<>
			 <Paper className='merchantAccountDetailsCard-content'>
				<div>
					<p className='merchantAccountDetailsCard-content-header' data-testid='content-header'>Details</p>
						<Divider />
						<div className='merchantAccountDetailsCard-content-body'>
							{content.map((item, index) => (
							<div className='merchantAccountDetailsCard-content-section' key={index}>
								 <p className='merchantAccountDetailsCard-content-subheader' data-testid='content-subheader'>{item.heading}</p>
								 {Array.isArray(item.text) ? (
								 <ul className='merchantAccountDetailsCard-content-header-text'>
									{item.text.map((listItem, listIndex) => (
									<li key={listIndex}>{listItem}</li>
									))}
								</ul>
								) : (
								<p className='merchantAccountDetailsCard-content-header-text'>{item.text}</p>
								)}
							</div>
							))}
						</div>
				</div>
			</Paper>
		</>
	)
}

 export default MerchantAccountDetailsCard;
